module.exports = __webpack_public_path__ + "img/pose-m-1.3b022a9b.png";